import { createApi } from '@reduxjs/toolkit/query/react';

import { ApiResponse } from '../../model';
import { API_CONSTANTS } from '../../utils/constants';
import { baseQueryWithReauth } from '../../apis/baseQuery';

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    toolsSettings: build.query<ApiResponse<any>, any>({
      query: (params) => ({
        url: `${API_CONSTANTS.BASE_URL}api/v1/tools/settings`,
        method: 'GET',
        params,
      }),
    }),
    updateSetting: build.mutation<ApiResponse<any>, any>({
      query: (body) => ({
        url: `${API_CONSTANTS.BASE_URL}api/v1/tools/settings-update`,
        method: 'PUT',
        body,
      }),
    }),
    getFileSettings: build.query<ApiResponse<any>, any>({
      query: (params) => ({
        url: `${API_CONSTANTS.BASE_URL}api/v1/tools/settings`,
        method: 'GET',
        params,
      }),
    }),
    fileUpload: build.mutation<ApiResponse<any>, any>({
      query: (body) => ({
        url: `${API_CONSTANTS.BASE_URL}api/v1/tools/settings-upload-files`,
        method: 'POST',
        body,
      }),
    }),
    resetSettings: build.mutation<ApiResponse<any>, any>({
      query: (body) => ({
        url: `${API_CONSTANTS.BASE_URL}api/v1/tools/reset-settings`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useLazyToolsSettingsQuery,
  useUpdateSettingMutation,
  useLazyGetFileSettingsQuery,
  useFileUploadMutation,
  useResetSettingsMutation,
} = settingsApi;
